import { useState } from "react";
import {
  Box, Button, Container, Grid2 as Grid, Modal, Typography,
  Backdrop, CircularProgress
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';

import { MODAL_MESSAGES } from "../../components/common/helpers";
import FormInversion from "../../components/investments/FormInversion";
import CardTrnasferencias from "../../components/investments/CardTrnasferencias";
import {
  uploadInvestment, addInvestment, sendEmailApproval, sendEmailAdmin
} from "../../actions/investments";

import { connect } from "react-redux";

const Investment = ({
  user, isAuthenticated,
  uploadInvestment, addInvestment, sendEmailAdmin
}) => {
  const navigate = useNavigate();
  const [newInvestment, setNewInvestment] = useState({
    monto: "",
    type: "paypal",
    card: "",
    exp: "",
    cvv: "",
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [loading, setLoading] = useState(false);

  //Redirect
  if (!isAuthenticated) {
    return <Navigate to="/" />
  }

  if (user && user.datos_empresas?.[0]?.status !== 1) {
    return <Navigate to="/datos-fiscales" />
  }

  const handleChange = (key, newValue) => {
    const newData = Object.assign({}, newInvestment);

    newData[key] = newValue;

    setNewInvestment(newData);
    setErrors({});
  }

  const uploadFile = async file => {
    const archivo = file[0];
    if (archivo) {
      setLoading(true);
      const formData = new FormData();
      const originalName = archivo.name.split('.').slice(0, -1).join('.');
      formData.append('file', archivo);
      formData.append('carpeta', `inversiones_index_dos/${user._id}`);
      formData.append('nombre', originalName);
      const info = {
        recibo: originalName,
        monto: 0
      }
      const emailInfo = {
        email: user.email,
        nombre: user.name,
        subject: 'confirmacion'
      };
      await addInvestment(info, user._id, user.datos_empresas[0]._id);
      await sendEmailApproval(emailInfo);
      await sendEmailAdmin();
      const res = await uploadInvestment(formData);
      if (res) {
        const result = MODAL_MESSAGES.SUCCESS_DOC;
        setModalContent(result);
        setLoading(false);
        setShowModal(true);
      }
    }
  }

  return (
    <>
      <Modal
        open={showModal}
        className="modal-content"
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-message modal-large">
          {modalContent.img && <img alt="modal-img" src={modalContent.img} />}
          <Typography className="titleMain" variant="h3" component="h3" mt={3}>
            {modalContent.title ?? '--'}
          </Typography>
          <Typography mt={3} mb={5}>
            {modalContent.subtitle ?? '--'}
          </Typography>
          <Button
            onClick={() => navigate('../detalle-inversiones')}
            type="button"
            variant="contained"
          >
            {modalContent.btnAction ?? 'OK'}
          </Button>
        </Box>
      </Modal>

      <section className="segment-header">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div className="transbox" />
        <Container className="content-headers" component="main" maxWidth="lg">
          <div>
            <Typography
              className="title"
              variant="h1"
              component="h1"
              sx={{ fontSize: { xs: '2.5rem', sm: '2.8rem', md: '3rem', lg: '3.5rem' } }}
            >
              Bienvenido
            </Typography>
            <Typography className="subtitle" variant="h6" component="h6">
              Conoce sobre esta oportunidad de inversión
            </Typography>
          </div>
          <Typography
            className="title-proyects"
            variant="h3"
            component="h3"
            sx={{ fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem', lg: '2.5rem' } }}
          >
            <small>Proyecto</small><br />
            One Service
          </Typography>
        </Container>
      </section>

      <Grid className="payment-section" container spacing={5}>
        <Grid className="content-form" size={{ md: 6, xl: 7 }} mt={5}>
          <FormInversion
            user={user}
            errors={errors}
            newInvestment={newInvestment}
            addInvestment={addInvestment}
            sendEmailApproval={sendEmailApproval}
            handleChange={handleChange}
            setModalContent={setModalContent}
            setShowModal={setShowModal}
            setLoading={setLoading}
          />
        </Grid>
        <Grid size={{ md: 6, xl: 5 }} mt={{ xs: 3, md: 5 }}>
          <CardTrnasferencias
            uploadFile={uploadFile}
            loading={loading}
          />
        </Grid>
      </Grid>
    </>
  );
}

Investment.propTypes = {
  uploadInvestment: PropTypes.func.isRequired,
  addInvestment: PropTypes.func.isRequired,
  sendEmailAdmin: PropTypes.func.isRequired,
  user: PropTypes.object,
  isAuthenticated: PropTypes.bool
}

const mapStateToProps = state => ({
  user: state.users.user,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps, {
  uploadInvestment,
  addInvestment,
  sendEmailAdmin
})(Investment);
